import type { DayOfWeek } from 'services/api';

export const translateDay = (day: DayOfWeek) => {
  const dictionary: Record<DayOfWeek, string> = {
    MONDAY: 'Пн',
    TUESDAY: 'Вт',
    WEDNESDAY: 'Ср',
    THURSDAY: 'Чт',
    FRIDAY: 'Пт',
    SATURDAY: 'Сб',
    SUNDAY: 'Вс',
  };

  return dictionary[day] ?? day;
};
